export const EMAIL_NOT_VERIFIED_STATUS_CODE = 409;
